import { ProductNotification } from '../../modules/pos/quotes/entities/products.class';

export class TooltipNotification {
  error: ProductNotification[];
  warning: ProductNotification[];
  info: ProductNotification[];

  constructor() {
    this.error = [];
    this.warning = [];
    this.info = [];
  }
}
